import { commonDoubleListBoxStyle } from './double-list-box-style';
import { convertToLocalStyle } from './utils/convert-style';
import { glyphIconStyle } from './glyph-icon-style';
import { paginationStyle, searchboxStyle } from './shared-styles-from-theme-fluent';
import type { CommonStylesPalette } from '../types.d';


// Audience selector style for IF functions on ad customizers UI
export const audienceSelectorStyle = ({ palette = {} as CommonStylesPalette, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '&': {
    '& .row': {
      margin: 0,
    },

    '& .col-sm-12': {
      padding: 0,
    },

    '& .panel-heading': {
      fontWeight: 'normal',
    },

    '& .form-control': {
      minWidth: 180,
      width: 'fit-content',
    },

    '& .DMP_doublelistbox_section': {
      '& .doubleListBox': {
        width: 1240,

        '& .dlb-filter-alignPlaceholder': {
          width: 608,

          '& .searchbox-input': {
            paddingLeft: 48,
            height: 48,
            width: '100%',
          },

          '& .form-control-feedback': {
            left: 0,
            lineHeight: '48px',
            height: 48,
            marginLeft: 16,
            position: 'absolute',
            width: 'fit-content',
          },
        },

        '& .layout-columns-element:nth-child(1)': {
          '& .panel-form': {
            '& .panel-heading': {
              margin: '-48px -1px 0 -1px',
              padding: 0,
            },

            '& .panel-body': {
              marginTop: 16,
            },
          },
        },

        '& .layout-columns-element': {
          boxSizing: 'content-box',
          padding: 0,
          width: 610,

          '& ~ .layout-columns-element': {
            paddingLeft: 10,
          },

          '& .panel-form': {
            border: [1, 'solid', '#BBB'],
            boxShadow: 'none',
            height: 352,
            marginTop: 48,
            padding: 0,

            '& .panel-heading': {
              backgroundColor: `${palette.white}`,
              border: 'none',
              padding: '0 8px',
            },

            '& .panel-body': {
              padding: 0,

              '& .dlb-source-container, & .dlb-selected-container': {
                '& .dlb-source-summary': {
                  padding: '0 8px',
                },

                '& .audience-association-selector-header': {
                  height: 36,
                  lineHeight: '20px',
                  padding: '5px 8px',

                  '& .audience-association-selector-header-table': {
                    width: 510,

                    '& .audience-association-selector-header-col': {
                      fontWeight: 600,
                      width: 'auto',
                    },

                    '& .audience-association-selector-header-listsize-col': {
                      '& .appListItem-text': {
                        textAlign: 'right',
                        width: 'auto',
                      },
                    },
                  },
                },

                '& .dlb-selectAll, .dlb-deselectAll': {
                  color: palette.themePrimary,
                  padding: '0 10px',
                  position: 'absolute',
                  right: 8,
                  zIndex: 1,

                  '& .arrow-button': {
                    display: 'none',
                  },
                },

                '& .dlb-selectAll': {
                  top: 106,
                },

                '& .dlb-deselectAll': {
                  top: 58,
                },

                '& .dlb-source-list, & .dlb-selected-list': {
                  height: 228,
                  overflowX: 'auto',
                  overflowY: 'auto',

                  '& .dlbItem': {
                    minHeight: 28,
                    position: 'relative',
                    padding: '0 8px',

                    '& .glyphicon-triangle-right, & .glyphicon-triangle-bottom': {
                      marginRight: 5,
                    },

                    '& .dlbItem-actions, & .remove': {
                      position: 'absolute',
                      right: 8,
                      margin: '4px 0',
                    },

                    '& .dlbItem-customAction, .arrow-button': {
                      textDecoration: 'none',

                      '&:focus': {
                        outline: 'solid 1px',
                        outlineOffset: 2,
                      },
                    },

                    '& .dlbItem-content': {
                      minHeight: 28,
                      padding: '4px 0',

                      '& table': {
                        width: 510,

                        '& .tree-indent': {
                          paddingLeft: 10,
                        },
                      },

                      '& table > tbody > tr > td:nth-child(1)': {
                        textAlign: 'left',
                        width: 'auto',
                      },
                      '& table > tbody > tr > td:nth-child(2)': {
                        textAlign: 'right',
                        width: 120,
                      },

                      '& span': {
                        wordBreak: 'break-word',
                      },
                    },
                  },

                  '& .disabled': {
                    '& .arrow-button:before': {
                      content: '""',
                    },
                  },
                },

                '& .dlb-source-list ul.list-container': {
                  listStyle: 'none',
                  paddingLeft: 0,
                },

                '& .dlb-selected-list': {
                  height: 276,
                },

                '& ::-webkit-scrollbar':
                {
                  width: 4,
                  backgroundColor: 'transparent',
                },

                '& ::-webkit-scrollbar-track':
                {
                  backgroundColor: 'transparent',
                },

                '& ::-webkit-scrollbar-thumb':
                {
                  width: 4,
                  height: 44,
                  backgroundColor: '#EBEAE8',
                },

                '& ::-webkit-scrollbar:horizontal':
                {
                  height: 4,
                  backgroundColor: 'transparent',
                },

                '& ::-webkit-scrollbar-track:horizontal':
                {
                  backgroundColor: 'transparent',
                },

                '& ::-webkit-scrollbar-thumb:horizontal':
                {
                  width: 200,
                  height: 4,
                  backgroundColor: '#EBEAE8',
                },
              },

              '& .dlb-emptyMessage, & .dlb-emptySelectedMessage': {
                padding: '0 8px',
                height: 36,
                lineHeight: '36px',
                marginBottom: 0,

                '& p': {
                  marginBottom: 0,
                },
              },

              '& .dlb-emptyMessage[style="display: none;"] + .dlb-source-list': {
                height: 236,
              },
            },
          },

          '& .dlb-pager-container': {
            width: 'fit-content',
            float: 'right',
            marginTop: 8,

            '& .pager': {
              height: 'auto',
            },
          },
        },
      },
    },

    ...commonDoubleListBoxStyle({ palette }),
    ...paginationStyle({ palette, iconFontFamily }),
    ...convertToLocalStyle(glyphIconStyle({ palette, iconFontFamily })),
    ...searchboxStyle({ palette, iconFontFamily }),
  },
});
